<div class="tags-wrapper">
    <div id="tagsList" class="tags-cloud">
        <div *ngIf="selectedTags?.length == 0">No Emails Selected</div>
        <div *ngFor="let selectedTag of selectedTags;let $index = index" class="tag">
            <span class="tagName">{{selectedTag.DisplayName}}</span>
            <span>&nbsp;<b style="cursor: default;" (click)="removeTag($index)"><i class="modus-icons align-bottom">close</i></b></span>
        </div>
        <div class="input-group" style="width: 100%">
            <input type="text" autocomplete="off" id="searchInput" (keydown)="checkKeyDown($event)" class="form-control" [(ngModel)]="searchText" (ngModelChange)="search()" [disabled]="disabled" />
            <span class="input-group-btn">
                <button type="button" class="btn btn-primary" (click)="addToSelectedTags(selectedIndex)" [disabled]="disabled"><span><i class="modus-icons align-bottom">add</i></span></button>
            </span>
        </div>
    </div>
    <ul id="suggestions" class="suggestions-list">
        <li *ngFor="let suggestion of suggestions;let $index = index" class="blockSpan" (click)="addToSelectedTags($index)" [ngClass]="{'active' : selectedIndex === $index}">{{suggestion.DisplayName}} ({{suggestion.EmailAddress}})</li>
    </ul>
</div>